<script lang="ts">
    let className = '';
    export { className as class };
</script>

<h3 class="text-xl font-bold {className}"><slot /></h3>
